import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/modules/shared.module';
import { ComponentsModule } from '../components/components.module';
import { DirectivesModule } from '../directives/directives.module';
import { ModalsModule } from '../modals/modals.module';
import { AgGridButtonRendererComponent } from './ag-grid-button-renderer/ag-grid-button-renderer.component';
import { AgGridNumberEditorComponent } from './ag-grid-number-editor/ag-grid-number-editor.component';
import { AgGridValueEditorComponent } from './ag-grid-value-editor/ag-grid-value-editor.component';
import { ExerciseCellRendererComponent } from './exercise-cell-renderer/exercise-cell-renderer.component';
import { ExerciseCellSearchComponent } from './exercise-cell-search/exercise-cell-search.component';
import { ExerciseRendererPipe } from './exercise-renderer.pipe';
import { ExerciseRendererService } from './exercise-renderer.service';
import { ExerciseSearchComponent } from './exercise-search/exercise-search.component';
import { WorkoutComponent } from './workout.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IonicModule,
    SharedModule,
    OverlayModule,
    DirectivesModule,
    ModalsModule,
    ComponentsModule
  ],
  declarations: [
    WorkoutComponent,
    ExerciseCellSearchComponent,
    ExerciseSearchComponent,
    ExerciseCellRendererComponent,
    AgGridNumberEditorComponent,
    AgGridButtonRendererComponent,
    ExerciseRendererPipe,
    AgGridValueEditorComponent,
  ],
  exports: [WorkoutComponent, ExerciseSearchComponent],
  providers: [ExerciseRendererService]
})
export class WorkoutViewerModule {}
